import { jsx as _jsx } from "react/jsx-runtime";
import { QuestionnaireFlow } from '../../redux/questionnaire/typings';
import Start from './subcomponents/Start';
import ContactFraud from './subcomponents/ContactFraud';
import Review from './subcomponents/Review';
import End from './subcomponents/End';
import TechnicalError from '../TechnicalError';
import CancelQuestionnaire from './subcomponents/CancelQuestionnaire';
import Exit from './subcomponents/Exit';
import APIError from './subcomponents/APIError';
import RedisputeNotEligible from './subcomponents/RedisputeNotEligible';
import RedisputeReview from './subcomponents/RedisputeReview';
import CantIdentifyDup from './subcomponents/CantIdentifyDup';
var StaticScreen = function (_a) {
    var _b;
    var step = _a.step;
    var stepToStaticScreen = (_b = {},
        _b[QuestionnaireFlow.APIError] = APIError,
        _b[QuestionnaireFlow.Start] = Start,
        _b[QuestionnaireFlow.ContactFraud] = ContactFraud,
        _b[QuestionnaireFlow.RedisputeNotEligible] = RedisputeNotEligible,
        _b[QuestionnaireFlow.Review] = Review,
        _b[QuestionnaireFlow.RedisputeReview] = RedisputeReview,
        _b[QuestionnaireFlow.End] = End,
        _b[QuestionnaireFlow.BusinessError] = TechnicalError,
        _b[QuestionnaireFlow.CancelQuestionnaire] = CancelQuestionnaire,
        _b[QuestionnaireFlow.CantIdentifyDup] = CantIdentifyDup,
        _b[QuestionnaireFlow.Exit] = Exit,
        _b);
    var StaticScreenToRender = stepToStaticScreen[step];
    return StaticScreenToRender ? _jsx(StaticScreenToRender, {}) : null;
};
export default StaticScreen;
//# sourceMappingURL=staticscreen.js.map